import { Avatar, Box, Typography, Chip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import moment from 'moment';
import ErrorHandler from '@Root/ErrorHandler';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './OrganizationCardRow.scss';

export default function OrganizationCardRow(props) {
    new ErrorHandler();
    const className = 'organizationCardRow';
    const isSelected = props.organizationCard?.id === props.selectedOrganizationCard?.id;

    const getInitials = (name) => {
        if (!name) return 'ORG';
        const words = name.trim().split(' ');
        if (words.length === 1) {
            return words[0].substring(0, 2).toUpperCase();
        }
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return '';
        return moment(timestamp).format('MMM DD, YYYY');
    };

    const getLocationText = () => {
        const parts = [];
        if (props.organizationCard?.state) parts.push(props.organizationCard.state);
        if (props.organizationCard?.country) parts.push(props.organizationCard.country);
        return parts.join(', ');
    };

    return (
        <div
            className={`${className} ${isSelected ? `${className}--selected` : ''}`}
            onClick={() => props.setSelectedOrganizationCard(props.organizationCard)}
        >
            <Box className={`${className}__container`}>
                {/* Avatar Section */}
                <Avatar
                    src={props.organizationCard?.photo}
                    className={`${className}__avatar`}
                    alt={props.organizationCard?.name}
                >
                    {!props.organizationCard?.photo && getInitials(props.organizationCard?.name)}
                </Avatar>

                {/* Content Section */}
                <Box className={`${className}__content`}>
                    <Box className={`${className}__header`}>
                        <Typography variant="subtitle1" className={`${className}__name`}>
                            {props.organizationCard?.name || 'Unnamed Organization'}
                        </Typography>
                        {props.organizationCard?.createTimeStamp && (
                            <Typography variant="caption" className={`${className}__date`}>
                                {formatDate(props.organizationCard.createTimeStamp)}
                            </Typography>
                        )}
                    </Box>

                    {/* Industry & Location */}
                    <Box className={`${className}__details`}>
                        {props.organizationCard?.industryType && (
                            <Chip
                                icon={<BusinessIcon />}
                                label={props.organizationCard.industryType}
                                size="small"
                                className={`${className}__chip`}
                            />
                        )}
                        {getLocationText() && (
                            <Box className={`${className}__location`}>
                                <LocationOnIcon className={`${className}__location__icon`} />
                                <Typography variant="caption" className={`${className}__location__text`}>
                                    {getLocationText()}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* Selection Indicator */}
                {isSelected && <div className={`${className}__indicator`} />}
            </Box>
        </div>
    );
}
